var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function _mergeNamespaces(n, m) {
  m.forEach(function(e) {
    Object.keys(e).forEach(function(k) {
      if (k !== "default" && !(k in n)) {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function() {
            return e[k];
          }
        });
      }
    });
  });
  return Object.freeze(n);
}
function flatten(arg) {
  if (!Array.isArray(arg)) {
    return arg;
  }
  return arg.reduce((acc, x) => acc.concat(flatten(x)), []);
}
function isSubset(candidate, array) {
  const set = new Set(array);
  for (const member of candidate) {
    if (!set.has(member)) {
      return false;
    }
  }
  return true;
}
function resetDebouncedFn() {
  this.pending = false;
  if (typeof this.id === "number") {
    clearTimeout(this.id);
    delete this.id;
    return true;
  }
  return false;
}
function debounce(functionToDebounce, milliseconds, thisArg) {
  const debFn = function debouncedFn(...args) {
    return new Promise((resolve, reject) => {
      debFn.reset();
      debFn.pending = true;
      function executor() {
        void (async () => {
          try {
            let output = functionToDebounce.apply(thisArg || this, args);
            if (output instanceof Promise) {
              output = await output;
            }
            resolve(output);
          } catch (err) {
            reject(err);
          } finally {
            debFn.reset();
          }
        })();
      }
      debFn.id = window.setTimeout(executor, milliseconds);
    });
  };
  debFn.reset = resetDebouncedFn.bind(debFn);
  return debFn;
}
function resetLockedFn() {
  this.pending = false;
  if (typeof this.id === "number") {
    window.cancelAnimationFrame(this.id);
    delete this.id;
    return true;
  }
  return false;
}
function lockToAnimationFrames(functionToLock, thisArg) {
  const lockFn = function lockedFn(...args) {
    if (lockFn.pending) {
      lockFn.reset();
    }
    lockFn.id = window.requestAnimationFrame(() => {
      if (functionToLock) {
        functionToLock.apply(thisArg || this, args);
      }
      lockFn.reset();
    });
    lockFn.pending = true;
  };
  lockFn.pending = false;
  lockFn.reset = resetLockedFn.bind(lockFn);
  return lockFn;
}
function onNextTick(fn, thisArg) {
  const boundFn = thisArg ? fn.bind(thisArg) : fn;
  setTimeout(boundFn, 0);
}
const Op = {
  add: (a, b) => a + b,
  and: (a, b) => a && b,
  band: (a, b) => a & b,
  bor: (a, b) => a | b,
  bxor: (a, b) => a ^ b,
  bnot: (a) => ~a,
  decr: (a) => a - 1,
  div: (a, b) => a / b,
  eq: (a, b) => a === b,
  exp: (a, b) => a ** b,
  gt: (a, b) => a > b,
  gte: (a, b) => a >= b,
  incr: (a) => a + 1,
  lshift: (a, b) => a << b,
  lt: (a, b) => a < b,
  lte: (a, b) => a <= b,
  mul: (a, b) => a * b,
  neg: (a) => -a,
  neq: (a, b) => a !== b,
  not: (a) => !a,
  or: (a, b) => a || b,
  rem: (a, b) => a % b,
  rshift: (a, b) => a >> b,
  rshift_zf: (a, b) => a >>> b,
  sub: (a, b) => a - b,
  xor: (a, b) => (a || b) && !(a && b)
};
function range(start, end) {
  if (!Number.isInteger(start)) {
    throw new Error("start must be an integer");
  }
  if (!Number.isInteger(end)) {
    throw new Error("end must be an integer");
  }
  return new Array(Math.abs(end - start) + 1).fill(start).map(start > end ? Op.sub : Op.add);
}
class CustomEvent {
  constructor(eventName, initDict = {}) {
    let event;
    if (typeof Event === "function") {
      event = new Event(eventName, initDict);
    } else {
      event = document.createEvent("Event");
      event.initEvent(eventName, initDict.bubbles, initDict.cancelable);
      for (const key of Object.keys(initDict)) {
        if (key !== "bubbles" && key !== "cancelable") {
          event[key] = initDict[key];
        }
      }
    }
    Object.setPrototypeOf(this, event);
    const descriptors = Object.getOwnPropertyDescriptors(Event.prototype);
    for (const propKey of Object.keys(descriptors)) {
      const descriptor = descriptors[propKey];
      for (const key of Object.keys(descriptor)) {
        if (typeof descriptor[key] === "function") {
          descriptor[key] = descriptor[key].bind(event);
        }
      }
    }
    Object.defineProperties(this, descriptors);
  }
}
const EDI_DOCUMENT_TYPE = Object.freeze({
  100: { name: "Insurance Plan Description" },
  101: { name: "Name and Address Lists" },
  104: { name: "Air Shipment Information" },
  106: { name: "Motor Carrier Rate Proposal" },
  107: { name: "Request for Motor Carrier Rate Proposal" },
  108: { name: "Response to a Motor Carrier Rate Proposal" },
  109: { name: "Vessel Content Details" },
  110: { name: "Air Freight Details and Invoice" },
  112: { name: "Property Damage Report" },
  120: { name: "Vehicle Shipping Order" },
  121: { name: "Vehicle Service" },
  124: { name: "Vehicle Damage" },
  125: { name: "Multilevel Railcar Load Details" },
  126: { name: "Vehicle Application Advice" },
  127: { name: "Vehicle Baying Order" },
  128: { name: "Dealer Information" },
  129: { name: "Vehicle Carrier Rate Update" },
  130: { name: "Student Educational Record (Transcript)" },
  131: { name: "Student Educational Record (Transcript) Acknowledgment" },
  135: { name: "Student Loan Application" },
  138: { name: "Testing Results Request and Report" },
  139: { name: "Student Loan Guarantee Result" },
  140: { name: "Product Registration" },
  141: { name: "Product Service Claim Response" },
  142: { name: "Product Service Claim" },
  143: { name: "Product Service Notification" },
  144: { name: "Student Loan Transfer and Status Verification" },
  146: { name: "Request for Student Educational Record (Transcript)" },
  147: { name: "Response to Request for Student Educational Record (Transcript)" },
  148: { name: "Report of Injury, Illness or Incident" },
  149: { name: "Notice of Tax Adjustment or Assessment" },
  150: { name: "Tax Rate Notification" },
  151: { name: "Electronic Filing of Tax Return Data Acknowledgment" },
  152: { name: "Statistical Government Information" },
  153: { name: "Unemployment Insurance Tax Claim or Charge Information" },
  154: { name: "Uniform Commercial Code Filing" },
  155: { name: "Business Credit Report" },
  157: { name: "Notice of Power of Attorney" },
  159: { name: "Motion Picture Booking Confirmation" },
  160: { name: "Transportation Automatic Equipment Identification" },
  161: { name: "Train Sheet" },
  169: { name: "Transportation Appointment Schedule Information" },
  170: { name: "Revenue Receipts Statement" },
  175: { name: "Court and Law Enforcement Notice" },
  176: { name: "Court Submission TYPE" },
  180: { name: "Return Merchandise Authorization and Notification" },
  185: { name: "Royalty Regulatory Report" },
  186: { name: "Insurance Underwriting Requirements Reporting" },
  188: { name: "Educational Course Inventory" },
  189: { name: "Application for Admission to Educational Institutions" },
  190: { name: "Student Enrollment Verification" },
  191: { name: "Student Loan Pre-Claims and Claims" },
  194: { name: "Grant or Assistance Application" },
  195: { name: "Federal Communications Commission (FCC) License Application" },
  196: { name: "Contractor Cost Data Reporting" },
  197: { name: "Real Estate Title Evidence" },
  198: { name: "Loan Verification Information" },
  199: { name: "Real Estate Settlement Information" },
  200: { name: "Mortgage Credit Report" },
  201: { name: "Residential Loan Application" },
  202: { name: "Secondary Mortgage Market Loan Delivery" },
  203: { name: "Secondary Mortgage Market Investor Report" },
  204: { name: "Motor Carrier Load Tender" },
  205: { name: "Mortgage Note" },
  206: { name: "Real Estate Inspection" },
  210: { name: "Motor Carrier Freight Details and Invoice" },
  211: { name: "Motor Carrier Bill of Lading", edifactId: "IFTMCE" },
  212: { name: "Motor Carrier Delivery Trailer Manifest" },
  213: { name: "Motor Carrier Shipment Status Inquiry" },
  214: { name: "Transportation Carrier Shipment Status Message" },
  215: { name: "Motor Carrier Pick-up Manifest" },
  216: { name: "Motor Carrier Shipment Pick-up Notification" },
  217: { name: "Motor Carrier Loading and Route Guide" },
  218: { name: "Motor Carrier Tariff Information" },
  219: { name: "Logistics Service Request" },
  220: { name: "Logistics Service Response" },
  222: { name: "Cartage Work Assignment" },
  223: { name: "Consolidators Freight Bill and Invoice" },
  224: { name: "Motor Carrier Summary Freight Bill Manifest" },
  225: { name: "Response to a Cartage Work Assignment" },
  240: { name: "Motor Carrier Package Status" },
  242: { name: "Data Status Tracking" },
  244: { name: "Product Source Information" },
  248: { name: "Account Assignment/Inquiry and Service/Status" },
  249: { name: "Animal Toxicological Data" },
  250: { name: "Purchase Order Shipment Management Document" },
  251: { name: "Pricing Support" },
  252: { name: "Insurance Producer Administration" },
  255: { name: "Underwriting Information Services" },
  256: { name: "Periodic Compensation" },
  260: { name: "Application for Mortgage Insurance Benefits" },
  261: { name: "Real Estate Information Request" },
  262: { name: "Real Estate Information Report" },
  263: { name: "Residential Mortgage Insurance Application Response" },
  264: { name: "Mortgage Loan Default Status" },
  265: { name: "Real Estate Title Insurance Services Order" },
  266: { name: "Mortgage or Property Record Change Notification" },
  267: { name: "Individual Life, Annuity and Disability Application" },
  268: { name: "Annuity Activity" },
  270: { name: "Eligibility, Coverage or Benefit Inquiry" },
  271: { name: "Eligibility, Coverage or Benefit Information" },
  272: { name: "Property and Casualty Loss Notification" },
  273: { name: "Insurance/Annuity Application Status" },
  274: { name: "Health Care Provider Information" },
  275: { name: "Patient Information" },
  276: { name: "Health Care Claim Status Request" },
  277: { name: "Health Care Claim Status Notification" },
  278: { name: "Health Care Services Insurance/Benefit Review Information" },
  280: { name: "Voter Registration Information" },
  285: { name: "Commercial Vehicle Safety and Credentials Information Exchange" },
  286: { name: "Commercial Vehicle Credentials" },
  288: { name: "Wage Determination" },
  290: { name: "Cooperative Advertising Agreements" },
  300: { name: "Reservation (Booking Request) (Ocean)" },
  301: { name: "Confirmation (Ocean)", edifactId: "IFTMBC" },
  303: { name: "Booking Cancellation (Ocean)" },
  304: { name: "Shipping Instructions" },
  309: { name: "U.S. Customs Manifest" },
  310: { name: "Freight Receipt and Invoice (Ocean)" },
  311: { name: "Canadian Customs Information" },
  312: { name: "Arrival Notice (Ocean)" },
  313: { name: "Shipment Status Inquiry (Ocean)" },
  315: { name: "Status Details (Ocean)" },
  317: { name: "Delivery/Pickup Order" },
  319: { name: "Terminal Information" },
  322: { name: "Terminal Operations and Intermodal Ramp Activity" },
  323: { name: "Vessel Schedule and Itinerary (Ocean)" },
  324: { name: "Vessel Stow Plan (Ocean)" },
  325: { name: "Consolidation of Goods In Container" },
  326: { name: "Consignment Summary List" },
  350: { name: "U.S. Customs Status Information" },
  352: { name: "U.S. Customs Carrier General Order Status" },
  353: { name: "U.S. Customs Events Advisory Details" },
  354: { name: "U.S. Customs Automated Manifest Archive Status" },
  355: { name: "U.S. Customs Acceptance/Rejection" },
  356: { name: "U.S. Customs Permit to Transfer Request" },
  357: { name: "U.S. Customs In-Bond Information" },
  358: { name: "U.S. Customs Consist Information" },
  361: { name: "Carrier Interchange Agreement (Ocean)" },
  362: { name: "Cargo Insurance Advice of Shipment" },
  404: { name: "Rail Carrier Shipment Information" },
  410: { name: "Rail Carrier Freight Details and Invoice" },
  411: { name: "Rail Carrier Freight Details and Invoice Summary" },
  412: { name: "Trailer or Container Repair Billing" },
  414: { name: "Rail Carhire Settlements" },
  417: { name: "Rail Carrier Waybill Interchange" },
  418: { name: "Rail Advance Interchange Consist" },
  419: { name: "Advance Car Disposition" },
  420: { name: "Car Handling Information" },
  421: { name: "Estimated Time of Arrival and Car Scheduling" },
  422: { name: "Shipper's Car Order" },
  423: { name: "Rail Industrial Switch List" },
  424: { name: "Rail Carrier Services Settlement" },
  425: { name: "Rail Waybill Request" },
  426: { name: "Rail Revenue Waybill" },
  427: { name: "Rail Waybill Response" },
  429: { name: "Railroad Retirement Activity" },
  431: { name: "Railroad Station Master File" },
  432: { name: "Rail Deprescription" },
  433: { name: "Railroad Reciprocal Switch File" },
  434: { name: "Railroad Mark Register Update Activity" },
  435: { name: "Standard Transportation Commodity Code (STCC) Master" },
  436: { name: "Locomotive Information" },
  437: { name: "Railroad Junctions and Interchanges Activity" },
  440: { name: "Shipment Weights" },
  451: { name: "Railroad Event Report" },
  452: { name: "Railroad Problem Log Inquiry or Advice" },
  453: { name: "Railroad Service Commitment Advice" },
  455: { name: "Railroad Parameter Trace Registration" },
  456: { name: "Railroad Equipment Inquiry or Advice" },
  460: { name: "Railroad Price Distribution Request or Response" },
  463: { name: "Rail Rate Reply" },
  466: { name: "Rate Request" },
  468: { name: "Rate Docket Journal Log" },
  470: { name: "Railroad Clearance" },
  475: { name: "Rail Route File Maintenance" },
  485: { name: "Ratemaking Action" },
  486: { name: "Rate Docket Expiration" },
  490: { name: "Rate Group Definition" },
  492: { name: "Miscellaneous Rates" },
  494: { name: "Rail Scale Rates" },
  500: { name: "Medical Event Reporting" },
  501: { name: "Vendor Performance Review" },
  503: { name: "Pricing History" },
  504: { name: "Clauses and Provisions" },
  511: { name: "Requisition" },
  517: { name: "Material Obligation Validation" },
  521: { name: "Income or Asset Offset" },
  527: { name: "Material Due-In and Receipt" },
  536: { name: "Logistics Reassignment" },
  540: { name: "Notice of Employment Status" },
  561: { name: "Contract Abstract" },
  567: { name: "Contract Completion Status" },
  568: { name: "Contract Payment Management Report" },
  601: { name: "U.S. Customs Export Shipment Information" },
  602: { name: "Transportation Services Tender" },
  620: { name: "Excavation Communication" },
  625: { name: "Well Information" },
  650: { name: "Maintenance Service Order" },
  715: { name: "Intermodal Group Loading Plan" },
  805: { name: "Contract Pricing Proposal" },
  806: { name: "Project Schedule Reporting" },
  810: { name: "Invoice", edifactId: "INVOIC" },
  811: { name: "Consolidated Service Invoice/Statement" },
  812: { name: "Credit/Debit Adjustment" },
  813: { name: "Electronic Filing of Tax Return Data" },
  814: { name: "General Request, Response or Confirmation" },
  815: { name: "Cryptographic Service Message" },
  816: { name: "Organizational Relationships" },
  818: { name: "Commission Sales Report" },
  819: { name: "Operating Expense Statement" },
  820: { name: "Payment Order/Remittance Advice", edifactId: "REMADV" },
  821: { name: "Financial Information Reporting" },
  822: { name: "Account Analysis" },
  823: { name: "Lockbox" },
  824: { name: "Application Advice", edifactId: "APERAK" },
  826: { name: "Tax Information Exchange" },
  827: { name: "Financial Return Notice" },
  828: { name: "Debit Authorization" },
  829: { name: "Payment Cancellation Request" },
  830: { name: "Planning Schedule with Release Capability", edifactId: "DELFOR" },
  831: { name: "Application Control Totals" },
  832: { name: "Price/Sales Catalog", edifactId: "PRICAT" },
  833: { name: "Mortgage Credit Report Order" },
  834: { name: "Benefit Enrollment and Maintenance" },
  835: { name: "Health Care Claim Payment/Advice" },
  836: { name: "Procurement Notices" },
  837: { name: "Health Care Claim" },
  838: { name: "Trading Partner Profile" },
  839: { name: "Project Cost Reporting" },
  840: { name: "Request for Quotation", edifactId: "REQUOTE" },
  841: { name: "Specifications/Technical Information" },
  842: { name: "Nonconformance Report" },
  843: { name: "Response to Request for Quotation", edifactId: "QUOTES" },
  844: { name: "Product Transfer Account Adjustment", edifactId: "SSDCLM" },
  845: { name: "Price Authorization Acknowledgment/Status", edifactId: "ATHSTS" },
  846: { name: "Inventory Inquiry/Advice", edifactId: "INVRPT" },
  847: { name: "Material Claim" },
  848: { name: "Material Safety Data Sheet" },
  849: { name: "Response to Product Transfer Account Adjustment" },
  850: { name: "Purchase Order", edifactId: "ORDERS" },
  851: { name: "Asset Schedule" },
  852: { name: "Product Activity Data", edifactId: "SLSRPT" },
  853: { name: "Routing and Carrier Instruction" },
  854: { name: "Shipment Delivery Discrepancy Information" },
  855: { name: "Purchase Order Acknowledgment", edifactId: "ORDRSP" },
  856: { name: "Advance Ship Notice/Manifest", edifactId: "DESADV" },
  857: { name: "Shipment and Billing Notice" },
  858: { name: "Shipment Information" },
  859: { name: "Freight Invoice" },
  860: { name: "Purchase Order Change", edifactId: "ORDCHG" },
  861: { name: "Receiving Advice/Acceptance Certificate", edifactId: "RECADV" },
  862: { name: "Shipping Schedule", edifactId: "DELJIT" },
  863: { name: "Report of Test Results" },
  864: { name: "Text Message" },
  865: { name: "Purchase Order Change", edifactId: "ORDRSP" },
  866: { name: "Production Sequence" },
  867: { name: "Product Transfer and Resale Report", edifactId: "SLSRPT" },
  868: { name: "Electronic Form Structure" },
  869: { name: "Order Status Inquiry", edifactId: "ORSSTA" },
  870: { name: "Order Status Report", edifactId: "ORDREP" },
  871: { name: "Component Parts Content" },
  872: { name: "Residential Mortgage Insurance Application" },
  875: { name: "Grocery Products Purchase Order" },
  876: { name: "Grocery Products Purchase Order Change" },
  877: { name: "Manufacturer Coupon Family Code Structure" },
  878: { name: "Product Authorization/De-authorization" },
  879: { name: "Price Information" },
  880: { name: "Grocery Products Invoice" },
  881: { name: "Manufacturer Coupon Redemption Detail" },
  882: { name: "Direct Store Delivery Summary Information" },
  883: { name: "Market Development Fund Allocation" },
  884: { name: "Market Development Fund Settlement" },
  885: { name: "Retail Account Characteristics" },
  886: { name: "Customer Call Reporting" },
  887: { name: "Coupon Notification" },
  888: { name: "Item Maintenance" },
  889: { name: "Promotion Announcement" },
  891: { name: "Deduction Research Report" },
  893: { name: "Item Information Request" },
  894: { name: "Delivery/Return Base Record" },
  895: { name: "Delivery/Return Acknowledgment or Adjustment" },
  896: { name: "Product Dimension Maintenance" },
  920: { name: "Loss or Damage Claim - General Commodities" },
  924: { name: "Loss or Damage Claim - Motor Vehicle" },
  925: { name: "Claim Tracer" },
  926: { name: "Claim Status Report and Tracer Reply" },
  928: { name: "Automotive Inspection Detail" },
  940: { name: "Warehouse Shipping Order" },
  943: { name: "Warehouse Stock Transfer Shipment Advice" },
  944: { name: "Warehouse Stock Transfer Receipt Advice" },
  945: { name: "Warehouse Shipping Advice" },
  947: { name: "Warehouse Inventory Adjustment Advice" },
  980: { name: "Functional Group Totals" },
  990: { name: "Response to a Load Tender" },
  996: { name: "File Transfer" },
  997: { name: "Functional Acknowledgment", edifactId: "CONTROL" },
  998: { name: "Set Cancellation" },
  999: { name: "Implementation Acknowledgment" }
});
function castToNumber() {
  return (target, key) => {
    const internalKey = `_${String(key)}`;
    Object.defineProperties(target, {
      [internalKey]: {
        enumerable: false,
        configurable: true,
        writable: true,
        value: void 0
      },
      [key]: {
        enumerable: true,
        configurable: true,
        get() {
          return this[internalKey];
        },
        set(newValue) {
          this[internalKey] = Number(newValue);
        }
      }
    });
  };
}
function debounced(ms) {
  return (target, propertyKey, descriptor) => {
    const originalDescriptorCopy = __spreadValues({}, descriptor);
    originalDescriptorCopy.get = function get() {
      const newDescriptorWithDebounced = __spreadValues({}, originalDescriptorCopy);
      newDescriptorWithDebounced.value = debounce(originalDescriptorCopy.value, ms, this);
      Object.defineProperty(this, propertyKey, newDescriptorWithDebounced);
      return newDescriptorWithDebounced.value;
    };
    originalDescriptorCopy.configurable = true;
    delete originalDescriptorCopy.writable;
    delete originalDescriptorCopy.value;
    return originalDescriptorCopy;
  };
}
function lockedToAnimationFrames(target, propertyKey, descriptor) {
  const originalDescriptorCopy = __spreadValues({}, descriptor);
  descriptor.get = function get() {
    const newDescriptor = __spreadValues({}, originalDescriptorCopy);
    newDescriptor.value = lockToAnimationFrames(originalDescriptorCopy.value, this);
    Object.defineProperty(this, propertyKey, newDescriptor);
    return newDescriptor.value;
  };
  descriptor.configurable = true;
  delete descriptor.writable;
  delete descriptor.value;
  return descriptor;
}
function simpleMetadataDecoratorApplicator(metadata, defaults, target, key, descriptor) {
  const updatedDescriptor = descriptor || Object.getOwnPropertyDescriptor(target, key);
  const getter = updatedDescriptor.get;
  const { value } = updatedDescriptor;
  updatedDescriptor.get = function get() {
    const self2 = this;
    const fn = value || getter.call(this);
    const boundFn = fn.bind(this);
    const updatedMetadata = __spreadValues(__spreadValues({}, defaults), metadata);
    for (const prop of Object.keys(defaults)) {
      if (typeof metadata[prop] === "function") {
        Object.defineProperty(boundFn, prop, {
          get() {
            return updatedMetadata[prop](self2);
          }
        });
      } else {
        boundFn[prop] = updatedMetadata[prop];
      }
    }
    Object.defineProperty(this, key, {
      writable: true,
      configurable: true,
      enumerable: updatedDescriptor.enumerable,
      value: boundFn
    });
    return boundFn;
  };
  delete updatedDescriptor.value;
  delete updatedDescriptor.writable;
  return updatedDescriptor;
}
function tickDelay(target, propertyKey, descriptor) {
  const originalDescriptorCopy = __spreadValues({}, descriptor);
  originalDescriptorCopy.get = function get() {
    const newDescriptor = __spreadValues({}, originalDescriptorCopy);
    const boundFn = originalDescriptorCopy.value.bind(this);
    newDescriptor.value = () => setTimeout(boundFn, 0);
    Object.defineProperty(this, propertyKey, newDescriptor);
    return newDescriptor.value;
  };
  originalDescriptorCopy.configurable = true;
  delete originalDescriptorCopy.writable;
  delete originalDescriptorCopy.value;
  return originalDescriptorCopy;
}
function constrain(n, range2) {
  if (!n || n < range2[0]) {
    return range2[0];
  }
  if (n > range2[1]) {
    return range2[1];
  }
  return n;
}
function decimalRound(num, decimalPlaces = 0) {
  const integralAndFractionalSplit = String(num).split(".");
  const allDecimalPlaces = integralAndFractionalSplit.length > 1 ? integralAndFractionalSplit[1].length : 0;
  let roundedNum = num;
  for (let i = allDecimalPlaces - 1; i >= decimalPlaces; i -= 1) {
    roundedNum = Number(`${Math.round(Number(`${roundedNum}e${i}`))}e-${i}`);
  }
  return roundedNum;
}
function toFileSizeString(n, precision = 2) {
  if (n > Number.MAX_SAFE_INTEGER) {
    throw new Error("Number is greater than MAX_SAFE_INTEGER; toFileSizeString does not support orders of magnitude higher than petabytes for this reason until BigInt achieves broad browser support.");
  }
  const magnitude = Math.min(Math.floor(Math.log(n) / Math.log(1024)), 5);
  const unit = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
  ][magnitude];
  const decimalPlaces = magnitude ? precision : 0;
  return decimalRound(n / 1024 ** magnitude, decimalPlaces).toFixed(decimalPlaces) + unit;
}
function crumblePath(path) {
  return typeof path === "string" ? path.match(/[^.[\]]+/g) || [] : [].concat(path);
}
function copyProperty(propName, sourceObject, destObject) {
  Object.defineProperty(destObject, propName, Object.getOwnPropertyDescriptor(sourceObject, propName));
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var objectTag = "[object Object]";
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e) {
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var funcProto = Function.prototype, objectProto = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty = objectProto.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
var objectToString = objectProto.toString;
var getPrototype = overArg(Object.getPrototypeOf, Object);
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isPlainObject(value) {
  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var lodash_isplainobject = isPlainObject;
function deepFreeze(obj) {
  Object.freeze(obj);
  for (const key of Object.keys(obj)) {
    const val = obj[key];
    if (lodash_isplainobject(val) || Array.isArray(val)) {
      deepFreeze(val);
    }
  }
}
var DiffChange;
(function(DiffChange2) {
  DiffChange2[DiffChange2["ADDITION"] = 0] = "ADDITION";
  DiffChange2[DiffChange2["DELETION"] = 1] = "DELETION";
  DiffChange2[DiffChange2["ALTERATION"] = 2] = "ALTERATION";
})(DiffChange || (DiffChange = {}));
function diff(o1, o2, parentPath = []) {
  let d = [];
  for (const key of new Set([...Object.keys(o1), ...Object.keys(o2)])) {
    const o1HasKey = Object.prototype.hasOwnProperty.call(o1, key);
    const o2HasKey = Object.prototype.hasOwnProperty.call(o2, key);
    if (o1HasKey && !o2HasKey) {
      d.push({
        type: 1,
        key,
        parentPath,
        objects: [o1, o2]
      });
    } else if (!o1HasKey && o2HasKey) {
      d.push({
        type: 0,
        key,
        parentPath,
        objects: [o1, o2]
      });
    } else if (lodash_isplainobject(o1[key]) && lodash_isplainobject(o2[key]) || Array.isArray(o1[key]) && Array.isArray(o2[key])) {
      d = d.concat(diff(o1[key], o2[key], [...parentPath, key]));
    } else if (o1[key] !== o2[key]) {
      d.push({
        type: 2,
        key,
        parentPath,
        objects: [o1, o2]
      });
    }
  }
  return d;
}
function forEachEntryDeep(object, fn) {
  for (const key of Object.keys(object)) {
    const value = object[key];
    if (lodash_isplainobject(value) || Array.isArray(value)) {
      forEachEntryDeep(value, fn);
    } else {
      fn(key, value, object);
    }
  }
}
function forEachNestedObject(object, fn, path = []) {
  fn(path, object);
  for (const key of Object.keys(object)) {
    const value = object[key];
    if (lodash_isplainobject(value) || Array.isArray(value)) {
      const newPath = path.concat(key);
      forEachNestedObject(value, fn, newPath);
    }
  }
}
function isNil$1(value) {
  return value == null;
}
var lodash_isnil = isNil$1;
var isNilImport = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": lodash_isnil
}, [lodash_isnil]));
var lodash_isempty$1 = { exports: {} };
(function(module, exports) {
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", objectTag2 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
  var dataViewTag = "[object DataView]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject2(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer2 = moduleExports ? root.Buffer : void 0, propertyIsEnumerable = objectProto2.propertyIsEnumerable;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg2(Object.keys, Object);
  var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise2 = getNative(root, "Promise"), Set2 = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap");
  var nonEnumShadows = !propertyIsEnumerable.call({ "valueOf": 1 }, "valueOf");
  var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
  function baseGetTag(value) {
    return objectToString2.call(value);
  }
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) || isHostObject2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString2.call(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function isArguments(value) {
    return isArrayLikeObject(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString2.call(value) == argsTag);
  }
  var isArray = Array.isArray;
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  function isArrayLikeObject(value) {
    return isObjectLike2(value) && isArrayLike(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isEmpty2(value) {
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isArguments(value))) {
      return !value.length;
    }
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) {
      return !value.size;
    }
    if (nonEnumShadows || isPrototype(value)) {
      return !nativeKeys(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty2.call(value, key)) {
        return false;
      }
    }
    return true;
  }
  function isFunction(value) {
    var tag = isObject(value) ? objectToString2.call(value) : "";
    return tag == funcTag || tag == genTag;
  }
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function stubFalse() {
    return false;
  }
  module.exports = isEmpty2;
})(lodash_isempty$1, lodash_isempty$1.exports);
var lodash_isempty = lodash_isempty$1.exports;
var isEmptyImport = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": lodash_isempty
}, [lodash_isempty$1.exports]));
const isNil = lodash_isnil || isNilImport;
const isEmpty$1 = lodash_isempty || isEmptyImport;
function getPath(object, path, defaultValue, allOptional = false) {
  if (isEmpty$1(path)) {
    return object;
  }
  let value = object;
  for (const crumb of crumblePath(path)) {
    let key = crumb;
    let optional;
    if (typeof crumb === "string") {
      [
        ,
        key,
        optional
      ] = /^([^?]+)(\?)?$/.exec(crumb);
    }
    value = value[key];
    if (isNil(value) && (optional || allOptional)) {
      return defaultValue;
    }
  }
  return isNil(value) ? defaultValue : value;
}
function omit(obj, ...keys) {
  const keySet = new Set(keys);
  const result = {};
  for (const k of Object.keys(obj)) {
    if (!keySet.has(k)) {
      result[k] = obj[k];
    }
  }
  return result;
}
const isEmpty = lodash_isempty || isEmptyImport;
function setPath(object, path, newValue) {
  if (typeof object !== "object") {
    throw new Error("object is required");
  }
  if (isEmpty(path)) {
    throw new Error("path is required");
  }
  const crumbs = crumblePath(path);
  const finalCrumb = crumbs.splice(crumbs.length - 1, 1)[0];
  let current = object;
  for (const crumb of crumbs) {
    current = current[crumb];
    if (typeof current !== "object") {
      throw new Error(`Cannot set value at given path: Path deadends at ${String(crumb)}`);
    }
  }
  current[finalCrumb] = newValue;
}
function* traversePath(object, path) {
  yield object;
  let obj = object;
  for (const crumb of crumblePath(path)) {
    obj = obj[crumb];
    yield obj;
  }
}
function mergeDeep(...objectsToMerge) {
  const result = {};
  for (const mergee of objectsToMerge) {
    for (const key of Object.keys(mergee)) {
      if (Object.prototype.hasOwnProperty.call(result, key) && Object.getOwnPropertyDescriptor(result, key).writable && lodash_isplainobject(result[key])) {
        result[key] = mergeDeep(result[key], mergee[key]);
      } else if (lodash_isplainobject(mergee[key])) {
        result[key] = mergeDeep({}, mergee[key]);
      } else {
        result[key] = mergee[key];
      }
    }
  }
  return result;
}
function mergePropertiesDeep(...objectsToMerge) {
  const result = {};
  for (const mergee of objectsToMerge) {
    for (const key of Object.keys(mergee)) {
      if (Object.prototype.hasOwnProperty.call(result, key) && Object.getOwnPropertyDescriptor(result, key).writable && lodash_isplainobject(result[key])) {
        result[key] = mergePropertiesDeep(result[key], mergee[key]);
      } else if (lodash_isplainobject(mergee[key])) {
        result[key] = mergePropertiesDeep({}, mergee[key]);
      } else {
        copyProperty(key, mergee, result);
      }
    }
  }
  return result;
}
function values(object) {
  const vals = [];
  for (const key of Object.keys(object)) {
    vals.push(object[key]);
  }
  return vals;
}
function code(strings, ...interpolations) {
  const s = strings.reduce((a, b, i) => `${a}${i <= interpolations.length ? String(interpolations[i - 1]) : ""}${b}`);
  const leadingWhitespace = Math.min(...s.split(/[\r\n]/).filter((l) => l.trim()).map((l) => /^ */.exec(l)[0].length));
  return s.replace(new RegExp(`^ {${leadingWhitespace}}`, "gm"), "").trim();
}
function parseFileSize(fileSize) {
  const unitMatch = /[A-Z]?B$/.exec(fileSize);
  if (!unitMatch) {
    throw new Error(`Input to parseFileSize ("${fileSize}") doesn't seem like a file size; cannot identify a unit (e.g. KB, GB)`);
  }
  const [unit] = unitMatch;
  const num = Number(fileSize.replace(unit, ""));
  if (Number.isNaN(num)) {
    throw new Error(`Could not parse a number out of input to parseFileSize ("${fileSize}")`);
  }
  const magnitude = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
  ].indexOf(unit);
  if (magnitude === -1) {
    throw new Error("parseFileSize does not support units above PB");
  }
  return Math.ceil(num * 1024 ** magnitude);
}
const REGEX_REPLACEMENT = /(<%=|{{)(.+?)(%>|}})/g;
const REGEX_IF = /<%\?(.+?)%>(.+?)<\/%>/g;
const SYMBOL_TEMPLATE_SOURCE = Symbol("sps.utils.templateSrc");
function template(string) {
  const fn = (data) => string.replace(REGEX_IF, (match, pathToCheck, content) => getPath(data, pathToCheck.trim()) ? content : "").replace(REGEX_REPLACEMENT, (match, _, pathToInterpolate) => getPath(data, pathToInterpolate.trim(), ""));
  fn[SYMBOL_TEMPLATE_SOURCE] = string;
  return fn;
}
function isTemplate(x) {
  return typeof x === "string" && (REGEX_REPLACEMENT.test(x) || REGEX_IF.test(x));
}
function isTemplateFn(x) {
  return typeof x === "function" && Object.prototype.hasOwnProperty.call(x, SYMBOL_TEMPLATE_SOURCE);
}
export { CustomEvent, DiffChange, EDI_DOCUMENT_TYPE, Op, castToNumber, code, constrain, copyProperty, crumblePath, debounce, debounced, decimalRound, deepFreeze, diff, flatten, forEachEntryDeep, forEachNestedObject, getPath, isSubset, isTemplate, isTemplateFn, lockToAnimationFrames, lockedToAnimationFrames, mergeDeep, mergePropertiesDeep, omit, onNextTick, parseFileSize, range, setPath, simpleMetadataDecoratorApplicator, template, tickDelay, toFileSizeString, traversePath, values };
